import React  from "react";
import ImageUpload from "./ImageUpload";
import cal from "../../../assets/wedding/images/cal.png";
import lo from "../../../assets/wedding/images/lo.png";

import pre1 from "../../../assets/wedding/images/ceremony1.jpg";
import pre2 from "../../../assets/wedding/images/ceremony2.jpg";
import pre3 from "../../../assets/wedding/images/ceremony3.jpg";
import pre4 from "../../../assets/wedding/images/ceremony4.jpg";
import civil from "../../../assets/wedding/images/civil.jpg";
import reception from "../../../assets/wedding/images/reception.jpg";
import wedding from "../../../assets/wedding/images/wedding.jpg";

const Calendar = ({details, getURL}) => {
  const guessPic = (ceremony, idx) => {
    const name = ceremony?.ceremony_name?.toLowerCase();
    if (name) {
      if (name.indexOf("reception")>=0) return reception;
      if (name.indexOf("wedding")>=0 && name.indexOf("pre ")<0) return wedding;
      if (name.indexOf("civil")>=0) return civil;
    }
    const pres=[pre1, pre2, pre3, pre4];
    return pres[idx % pres.length];
  }

  const dateFormat = new Intl.DateTimeFormat("en-uk", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const timeFormat =  new Intl.DateTimeFormat("en-uk", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "Europe/London",
  });


  const prettyDate = (t) => {
    var d = new Date(t);
    var gt = d.getTime();
    if (isNaN(gt) || gt<1) return "";
    return dateFormat.format(d);
  }

  const prettyTime = (t) => {
    var d = new Date(t);
    var gt = d.getTime();
    if (isNaN(gt) || gt<1) return "";
    return timeFormat.format(d);    
  }


  return (
    <div id="calendar">
      <section className="web-inner-page">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="web-top-title"> Event Details </div>
            </div>
          </div>

          {details?.ceremonies.map((ceremony, i) => <>
            {(i % 2===0) ? <>

              <div className="row top-wedding-panel flex">
                <div className="col-lg-6 col-md-12 web-img order-2 order-lg-1">
                  <ImageUpload
                    canEdit={details.owner}
                    defaultImage={getURL("ceremony_"+ceremony.id, guessPic(ceremony, i))}
                    imageName={"ceremony_"+ceremony.id}
                    imageClass="main-image-1"
                    alt={ceremony.ceremony_name}
                  />
                </div>

                <div className="col-lg-6 col-md-12 web-content-box order-1 order-lg-2">
                  <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                    <div className="w-75">
                      <div className="web-title-n1 pt-0">{ceremony.ceremony_name}</div>
                      <div className="web-date-box">
                        <img src={cal} className="main-cal-1" alt="img" />
                        {prettyDate(ceremony.ceremony_time)}
                      </div>
                      <div className="web-date-box">
                        <img src={cal} className="main-cal-1" alt="img" style={{opacity:0}} />
                        {prettyTime(ceremony.ceremony_time)}
                      </div>
                      <div className="web-ad-box">
                        <img src={lo} className="main-lo-1" alt="img" />
                        {ceremony.ceremony_venue}
                      </div>
                      {/*<div className="web-dress-box">Dress Code : Bright & bling</div>*/}
                      </div>
                    </div>
                </div>
                <div className="crl"></div>
              </div>

            </> : <>

            <div className="row top-wedding-panel wedding-p2">
              <div className="col-lg-6 col-md-12 web-content-box">
                <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                  <div className="w-75">
                    <div className="web-title-n1 pt-0">{ceremony.ceremony_name}</div>
                    <div className="web-date-box">
                      <img src={cal} className="main-cal-1" alt="img" />
                      {prettyDate(ceremony.ceremony_time)}
                    </div>
                    <div className="web-date-box">
                      <img src={cal} className="main-cal-1" alt="img" style={{opacity:0}} />
                      {prettyTime(ceremony.ceremony_time)}
                    </div>
                    <div className="web-ad-box">
                      <img src={lo} className="main-lo-1" alt="img" />
                      {ceremony.ceremony_venue}
                    </div>
                    {/*<div className="web-dress-box">
                      {" "}
                      Dress Code : Bright & bling
                    </div>*/}
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 web-img">
                <ImageUpload
                  canEdit={details.owner}
                  defaultImage={getURL("ceremony_"+ceremony.id, guessPic(ceremony, i))}
                  imageName={"ceremony_"+ceremony.id}
                  imageClass="main-image-1"
                  alt={ceremony.ceremony_name}
                />

                {/* <img src={imgL} className="main-image-1" alt="img" /> */}
              </div>
            </div>


            </>}
          </>)}

        </div>
      </section>
    </div>
  );
};

export default Calendar;
